import React from "react";
import { CustomSection } from "components/MainSectionTemplate/types";
import HubSpotCompanyPanel from "HubSpot/HubSpotCompanyPanel";

export const hubSpotSection = (company: server.dto.Company, displayHubSpotPanel: boolean): CustomSection => {
  return {
    type: "custom",
    key: "hsCompanySection",
    render: () => <HubSpotCompanyPanel
      key="hsCompanySection"
      company={company}
    />,
    hidden: !displayHubSpotPanel,
  }
}